// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_wrapper__Tu8gw {
  display: block;
  position: relative;
  padding-left: 28px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 300;
  line-height: 18px;
  color: rgba(255, 255, 255, 0.8);
  letter-spacing: -0.015em;
  text-transform: capitalize;
}

.styles_label__0m0f4 {
  display: flex;
  align-items: center;
}

.styles_input__dhEnI {
  position: absolute;
  cursor: pointer;
  height: 0;
  width: 0;
  left: -10000px;
}
.styles_input__dhEnI:checked ~ .styles_radio__HQq1X {
  background-color: #ff136d;
}
.styles_input__dhEnI:checked ~ .styles_radio__HQq1X::after {
  opacity: 1;
}

.styles_radio__HQq1X {
  position: absolute;
  top: 0;
  left: 0;
  height: 16px;
  width: 16px;
  background: #414141;
  border-radius: 50%;
}
.styles_radio__HQq1X::after {
  content: "";
  position: absolute;
  opacity: 0;
  top: 25%;
  left: 25%;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #080808;
}`, "",{"version":3,"sources":["webpack://./src/components/ui/input/inputRadio/styles.module.scss","webpack://./src/assets/styles/variables/colors.scss"],"names":[],"mappings":"AAEA;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,+BCFS;EDGT,wBAAA;EACA,0BAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;AADF;;AAIA;EACE,kBAAA;EACA,eAAA;EACA,SAAA;EACA,QAAA;EACA,cAAA;AADF;AAII;EACE,yBCnBC;ADiBP;AAIM;EACE,UAAA;AAFR;;AAQA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,mBChBW;EDiBX,kBAAA;AALF;AAOE;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,mBCnCW;AD8Bf","sourcesContent":["@import './src/assets/styles/variables/colors';\n\n.wrapper {\n  display: block;\n  position: relative;\n  padding-left: 28px;\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: 300;\n  line-height: 18px;\n  color: $white-80;\n  letter-spacing: -0.015em;\n  text-transform: capitalize;\n}\n\n.label {\n  display: flex;\n  align-items: center;\n}\n\n.input {\n  position: absolute;\n  cursor: pointer;\n  height: 0;\n  width: 0;\n  left: -10000px;\n\n  &:checked {\n    ~ .radio {\n      background-color: $pink;\n\n      &::after {\n        opacity: 1;\n      }\n    }\n  }\n}\n\n.radio {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 16px;\n  width: 16px;\n  background: $grey-input;\n  border-radius: 50%;\n\n  &::after {\n    content: '';\n    position: absolute;\n    opacity: 0;\n    top: 25%;\n    left: 25%;\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    background: $black-nav-bg;\n  }\n}\n","$white: #ffffff;\n$white-3: rgba($white, 0.03);\n$white-4: rgba($white, 0.04);\n$white-5: rgba($white, 0.05);\n$white-10: rgba($white, 0.1);\n$white-30: rgba($white, 0.3);\n$white-50: rgba($white, 0.5);\n$white-70: rgba($white, 0.7);\n$white-80: rgba($white, 0.8);\n$white-90: rgba($white, 0.9);\n$pink: #ff136d;\n$pink-10: rgba($pink, 0.1);\n$pink-15: rgba($pink, 0.15);\n$black: #000000;\n$black-5: rgba($black, 0.05);\n$black-15: rgba($black, 0.15);\n$black-26: rgba($black, 0.26);\n$black-30: rgba($black, 0.3);\n$black-70: rgba($black, 0.7);\n$black-87: rgba($black, 0.87);\n$black-bg: #100f0f;\n$black-nav-bg: #080808;\n$black-footer: #0a0a0a;\n$blue: #443de9;\n$blue-btn: #453fd6;\n$blue-btn-15: rgba($blue-btn, 0.15);\n$blue-btn-40: rgba($blue-btn, 0.4);\n$grey-nav: #b6b6b6;\n$grey-input: #414141;\n$orange: #f5b300;\n$orange-5: rgba($orange, 0.05);\n$green: #12bc56;\n$red: #d33030;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `styles_wrapper__Tu8gw`,
	"label": `styles_label__0m0f4`,
	"input": `styles_input__dhEnI`,
	"radio": `styles_radio__HQq1X`
};
export default ___CSS_LOADER_EXPORT___;
